import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import Modal from '@components/Modal'
// import moment from 'moment'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
const Create = (props) => {
  const { setModalCreateOpen, modalCreateOpen } = props
  const { t } = useLocalization()
  const history = useHistory()
  const handleSubmit = async (data) => {
    data.start = data.startToEnd[0].format('YYYY-MM-DD HH:mm:ss')
    data.end = data.startToEnd[1].format('YYYY-MM-DD HH:mm:ss')
    delete data.startToEnd

    setModalCreateOpen(false)

    try {
      await client.post('/special-event', data)
      message.success('สำเร็จ')
      history.push('/special-event')
    } catch (e) {
      console.log(e)
      console.log(e.response.data)
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <>
      <Modal
        borderRadius
        centered={true}
        title={t('rewards.specialEvent.listScreen.create')}
        open={modalCreateOpen}
        onCancel={() => setModalCreateOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent handleSubmit={handleSubmit} doStatus="create" />
      </Modal>
    </>
  )
}

Create.propTypes = {
  setModalCreateOpen: PropTypes.func,
  modalCreateOpen: PropTypes.bool,
}

export default Create
